import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin/salus-standalone-work`

// 칸반 + 스케쥴 !!!!

// 체크리스트 그룹 생성 (그룹 + 아이템 함께 생성)
export const createChecklistGroup = async (param) => {
  try {
    const res = await axios.post(`${baseUrl}/checklist/groups`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 체크리스트 그룹 조회 (페이지네이션, 아이템 포함)
// @RequestParam Integer salusUserId, @ParameterObject Pageable pageable
export const getChecklistGroup = async ({
  salusUserId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}/checklist/groups`, {
      params: { salusUserId, page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 체크리스트 그룹 단일 조회
export const getChecklistGroupById = async (id) => {
  try {
    const res = await axios.get(`${baseUrl}/checklist/groups/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 체크리스트 그룹 수정 (그룹 + 아이템 함께 수정)
// DTO 형태: { salusUserId: number, title: string, items: string[] }
export const updateChecklistGroup = async (id, param) => {
  try {
    const res = await axios.post(`${baseUrl}/checklist/groups/${id}`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// 체크리스트 그룹 삭제
export const deleteChecklistGroup = async (id) => {
  try {
    const res = await axios.delete(`${baseUrl}/checklist/groups/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 생성
 * @param {*} param { title: string, scheduledDate: string (YYYY-MM-DD), salusUserId: number, checklistGroupId: number? }
 * @returns
 */
export const createStandaloneScheduledTask = async (param) => {
  try {
    const res = await axios.post(`${baseUrl}/scheduled-task`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * fastlane task 생성
 * @param {} param
 * @returns
 */
export const createStandaloneFastlaneTask = async (param) => {
  try {
    const res = await axios.post(`${baseUrl}/fastlane`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * routine task 생성
 * @param {} param
 * @returns
 */
export const createStandaloneRoutineTask = async (param) => {
  try {
    const res = await axios.post(`${baseUrl}/routine`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * routine 수정
 * @param {*} id - routine id
 * @param {*} param
 * @returns
 */
export const updateStandaloneRoutine = async (id, param) => {
  try {
    const res = await axios.post(`${baseUrl}/routine/${id}`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// /**
//  * 오늘 루틴 조회
//  * @param {} param0
//  * @returns
//  */
// export const getTodayRoutineTasks = async ({
//   salusUserId,
//   page = 0,
//   size = 10,
//   sort = 'createdAt,desc',
// }) => {
//   try {
//     const res = await axios.get(`${baseUrl}/routines/today`, {
//       params: { salusUserId, page, size, sort },
//     })
//     return res
//   } catch (error) {
//     console.error('error::', error)
//     throw error
//   }
// }

// /**
//  * 이번주 루틴 조회
//  * @param {} param0
//  * @returns
//  */
// export const getWeeklyRoutineTasks = async ({
//   salusUserId,
//   page = 0,
//   size = 10,
//   sort = 'createdAt,desc',
// }) => {
//   try {
//     const res = await axios.get(`${baseUrl}/routines/week`, {
//       params: { salusUserId, page, size, sort },
//     })
//     return res
//   } catch (error) {
//     console.error('error::', error)
//     throw error
//   }
// }

export const getTodayWorkTasks = async ({
  salusUserId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}/works/today`, {
      params: { salusUserId, page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

export const getWeeklyWorkTasks = async ({
  salusUserId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}/works/week`, {
      params: { salusUserId, page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Fastlane 업무 완료
 * @param {*} id
 * @returns
 */
export const completeStandaloneFastlane = async (id, salusUserId) => {
  try {
    const res = await axios.post(`${baseUrl}/fastlane/${id}/complete`, null, {
      params: { salusUserId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Fastlane 업무 미완료
 * @param {*} id
 * @returns
 */
export const incompleteStandaloneFastlane = async (id, salusUserId) => {
  try {
    const res = await axios.post(`${baseUrl}/fastlane/${id}/incomplete`, null, {
      params: { salusUserId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

export const getStandaloneFastlaneTask = async (id) => {
  try {
    const res = await axios.get(`${baseUrl}/fastlane/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Fastlane 업무 수정
 * @param {*} id
 * @param {*} param { title: string, endDateTime: string, salusUserId: number }
 * @returns
 */
export const updateStandaloneFastlaneTask = async (id, param) => {
  try {
    const res = await axios.post(`${baseUrl}/fastlane/${id}`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Fastlane 업무 삭제
 * @param {*} id
 * @returns
 */
export const deleteStandaloneFastlaneTask = async (id) => {
  try {
    const res = await axios.delete(`${baseUrl}/fastlane/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone routineItem > checklist 완료
 * @param {*} id
 * @returns
 */
export const toggleChecklistItem = async (historyId, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/checklist/history/${historyId}/toggle`,
      null,
      {
        params: { salusUserId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone routineItem 완료
 * @param {*} id
 * @returns
 */
export const completeStandaloneRoutine = async (id, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/routine-item/${id}/complete`,
      null,
      {
        params: { salusUserId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone routineItem 미완료
 * @param {*} id
 * @returns
 */
export const incompleteStandaloneRoutine = async (id, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/routine-item/${id}/incomplete`,
      null,
      {
        params: { salusUserId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 *
 * @param {*} id, year, month
 * @param {*} salusUserId
 * @returns
 */
export const getCalendarWorkItems = async (id, year, month, salusUserId) => {
  try {
    const res = await axios.get(`${baseUrl}/works/calendar`, {
      params: { id, year, month, salusUserId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// export const getCalendarRoutineWorkItems = async (
//   id,
//   year,
//   month,
//   salusUserId,
// ) => {
//   try {
//     const res = await axios.get(`${baseUrl}/routine-items/calendar`, {
//       params: { id, year, month, salusUserId },
//     })
//     return res
//   } catch (error) {
//     console.error('error::', error)
//     throw error
//   }
// }

export const getStandaloneRoutineItem = async (id, salusUserId) => {
  try {
    const res = await axios.get(`${baseUrl}/routine-item/${id}`, {
      params: { salusUserId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 단일 조회
 * @param {*} id - Task ID
 * @returns
 */
export const getStandaloneScheduledTask = async (id) => {
  try {
    const res = await axios.get(`${baseUrl}/scheduled-task/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 리스트 조회
 * @param {*} param { salusUserId: number, page: number, size: number, sort: string }
 * @returns
 */
export const getStandaloneScheduledTasks = async ({
  salusUserId,
  page = 0,
  size = 10,
  sort = 'createdAt,desc',
}) => {
  try {
    const res = await axios.get(`${baseUrl}/scheduled-tasks`, {
      params: { salusUserId, page, size, sort },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 수정
 * @param {*} id - Task ID
 * @param {*} param { title: string, scheduledDate: string (YYYY-MM-DD), salusUserId: number }
 * @returns
 */
export const updateStandaloneScheduledTask = async (id, param) => {
  try {
    const res = await axios.post(`${baseUrl}/scheduled-task/${id}`, param)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 삭제
 * @param {*} id - Task ID
 * @returns
 */
export const deleteStandaloneScheduledTask = async (id) => {
  try {
    const res = await axios.delete(`${baseUrl}/scheduled-task/${id}`)
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 완료 처리
 * @param {*} id - Task ID
 * @param {*} salusUserId - User ID
 * @returns
 */
export const completeStandaloneScheduledTask = async (id, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/scheduled-task/${id}/complete`,
      null,
      {
        params: { salusUserId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * Standalone Scheduled Task 미완료 처리
 * @param {*} id - Task ID
 * @param {*} salusUserId - User ID
 * @returns
 */
export const incompleteStandaloneScheduledTask = async (id, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/scheduled-task/${id}/incomplete`,
      null,
      {
        params: { salusUserId },
      },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * ScheduledTaskTodoItem 토글
 * @param {*} id - todoItem id
 * @param {*} salusUserId
 * @returns
 */
export const toggleScheduledTaskTodoItem = async (id, salusUserId) => {
  try {
    const res = await axios.post(
      `${baseUrl}/scheduled-task-todo-item/${id}/toggle`,
      { salusUserId },
    )
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * RoutineTodoItem 토글
 * @param {*} id - todoItem id
 * @param {*} salusUserId
 * @returns
 */
export const toggleRoutineItemTodoItem = async (id, salusUserId) => {
  try {
    const res = await axios.post(`${baseUrl}/routine-todo-item/${id}/toggle`, {
      salusUserId,
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

// ------------------------------------------------------------
// ------------------------------------------------------------
export const getStandaloneAdminData = async (teamGroupId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_HOST}/admin/salus-ops/dashboard/team/${teamGroupId}`,
    )
    return res.data
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * 스튜디오 레벨 Ops 대시보드 데이터 (해당 스튜디오 내 모든 팀 집계)
 * @param {number} studioGroupId
 * @returns {Promise<{ pendingWorks: [], pendingCount: number, resolvedWorks24h: [], resolvedCount: number }>}
 */
export const getStandaloneAdminDataByStudio = async (studioGroupId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_HOST}/admin/salus-ops/dashboard/studio/${studioGroupId}`,
    )
    return res.data
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 *
 * @param {*} year, month
 * @param {*} teamGroupId
 * @returns
 */
export const getCalendarAdminWorkItems = async ({
  year,
  month,
  teamGroupId,
}) => {
  try {
    const res = await axios.get(`${baseUrl}/works/calendar/team`, {
      params: { teamGroupId, year, month },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}

/**
 * 루틴 삭제 (루틴 아이템도 전체 삭제 됨)
 * @param {*} id -
 * @returns
 */
export const deleteStandaloneRoutine = async (id, salusUserId) => {
  try {
    const res = await axios.delete(`${baseUrl}/routine/${id}`, {
      params: { salusUserId },
    })
    return res
  } catch (error) {
    console.error('error::', error)
    throw error
  }
}
